<script>
import ValidationMixin from "@/mixins/validation.mixin.ts";
import { mapActions } from "pinia";
import { computed, reactive } from "vue";
import { useSnackbarStore } from "@/store/snackbar.store.ts";
import DispatchConfirmationForm from "@/views/trips/components/forms/DispatchConfirmationForm.vue";
import { useError } from "@/composables/useError.ts";
import { usePipStore } from "@/store/pip.store.ts";
import PermissionTooltip from "@/components/tooltips/PermissionTooltip.vue";
import { DispatcherPermissionValue } from "@/api/dto/dispatcher.dto.ts";

const { showAPIError } = useError();

export default {
  name: "DispatchConfirmationAction",
  components: { PermissionTooltip },
  mixins: [ValidationMixin],
  inheritAttrs: false,
  props: {
    trip: Object,
    route: Object,
  },
  emits: ["dispatched"],
  setup() {
    const pipStore = usePipStore();

    return { pipStore };
  },
  data() {
    return {
      loading: false,
      checkCallPreview: null,
    };
  },
  computed: {
    DispatcherPermissionValue() {
      return DispatcherPermissionValue;
    },
  },
  methods: {
    ...mapActions(useSnackbarStore, ["showSnackbarError"]),
    showDispatchConfirmation() {
      this.checkCallPreview = null;

      this.pipStore.open({
        component: DispatchConfirmationForm,
        props: reactive({
          orders: computed(() => (this.route.travelOrders || []).map((travelOrder) => travelOrder.order)),
          routeId: computed(() => this.route.id),
          routeStops: computed(() => this.route.routeStops),
          creationLoading: computed(() => this.loading),
          checkCallPreview: computed(() => this.checkCallPreview),
          truckId: computed(() => this.route.truck?.id),
          truckNumber: computed(() => this.route.truck?.number),
          tripId: computed(() => this.trip.id),
          title: computed(() => (this.checkCallPreview ? "Dispatch preview" : "Dispatch confirmation")),
        }),
        on: {
          create: (data) => this.confirmDispatched(data),
          edit: () => (this.checkCallPreview = null),
          close: () => this.pipStore.close(),
        },
      });
    },
    async confirmDispatched(data) {
      this.loading = true;

      try {
        const response = await this.$api.trips.confirmRouteDispatch(this.trip.id, this.route.id, data);

        if (!response.success || !response.data) {
          showAPIError(response, "Error dispatching route");

          return;
        }

        if (!data.commit) {
          this.checkCallPreview = response.data;
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<template>
  <permission-tooltip :permission="DispatcherPermissionValue.TripsRouteActions">
    <template #activator="{ disabled }">
      <v-btn
        v-if="!route?.dispatchConfirmed"
        :disabled="disabled"
        block
        class="text-uppercase font-weight-600"
        color="primary"
        v-bind="$attrs"
        variant="flat"
        @click="showDispatchConfirmation"
      >
        Confirm dispatch
      </v-btn>
    </template>

    {{ $t("permission.process-trip") }}
  </permission-tooltip>
</template>

<style lang="scss" scoped></style>
